// extracted by mini-css-extract-plugin
export var divider = "_qp-0";
export var systemMessage = "_qp-1";